import { render, staticRenderFns } from "./ModalTraslate.vue?vue&type=template&id=d855714a&"
import script from "./ModalTraslate.vue?vue&type=script&lang=js&"
export * from "./ModalTraslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports